
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import PaymentOptions from "@/components/PaymentOptions";
import { useCredits } from "@/hooks/useCredits";

interface ResumePaymentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onPayment: (useCredit: boolean) => void;
  selectedFormat?: "pdf" | "docx";
  isProcessing?: boolean;
}

const ResumePaymentDialog = ({ 
  open, 
  onOpenChange, 
  onPayment,
  selectedFormat = "pdf",
  isProcessing = false
}: ResumePaymentDialogProps) => {
  const { credits } = useCredits();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Download Resume</DialogTitle>
          <DialogDescription>
            Download this optimized resume in {selectedFormat.toUpperCase()} format
          </DialogDescription>
        </DialogHeader>
        <PaymentOptions
          credits={credits}
          onUseCredit={() => onPayment(true)}
          onDirectPayment={() => onPayment(false)}
          onPurchaseCredits={() => {}}
          isProcessing={isProcessing}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ResumePaymentDialog;
